import { createSlice } from "@reduxjs/toolkit";
import { saveClientFacilityState } from "./userLocalStorage";

const userSlice = createSlice({
  name: "clientFacility",
  initialState: {
    client: null,
    facility: null,
  },
  reducers: {
    setUserData: (state, action) => {
      const { client, facility } = action.payload;

      // Only update client if provided
      if (client !== undefined ) {
        state.client = client;
       
      }
  
      // Only update facility if provided
      if (facility !== undefined) {
        state.facility = facility;
       
      }

  
      saveClientFacilityState(state);  // Save to localStorage
    },
    clearUserData: (state) => {
      state.client = null;
      state.facility = null;
      saveClientFacilityState(state); // Clear in localStorage
    },
  },
});

export const { setUserData, clearUserData } = userSlice.actions;
export default userSlice.reducer;
